import { HttpClient } from '@angular/common/http';
import { AppInjector } from './inject';

var httpClient: HttpClient;

const htmlparser2 = require('htmlparser2');

function getPromise(url: string) {
  if (!httpClient)
    httpClient = AppInjector.get(HttpClient);
  return httpClient.get(url, {responseType: 'text'}).toPromise();
}

function convertFolderHtmlToList(html: string): string[] {
  let result = new Array<string>();

  let textIsFile = false;
  const parser = new htmlparser2.Parser({
    onopentag(name: string, attributes) {
      if (name == 'a' && attributes.href != '/')
        textIsFile = true;
    },
    ontext(text: string) {
      if (textIsFile) {
        result.push(text);
        textIsFile = false;
      }
    }
  });
  parser.write(html);
  parser.end();

  return result;
}

// Return string array
export async function getFilesInFolder(url: string, filesFilter?: RegExp) {
  let promise = getPromise(url);
  let html: string;

  await promise.then((response) => {
    html = response;
  }).catch((response: any) => {
    console.error(response);
  });

  let files = convertFolderHtmlToList(html);

  if (filesFilter)
    files = files.filter(f => f.match(filesFilter));
  
  return files;
}
